import gql from 'fraql'
import {fragments} from './fragments'
import {ORDER_INFO_MANAGEMENT} from './graphql'

export default {
  filterStreets: gql`query filterStreets($name: String) {
    filterStreets(name: $name) {
      nodes
    }
  }`,
  PRODUCTS_OF_ORDER: gql`
  query productsOfOrder($id: Int!) {
    allProductOrders(condition: {idOrder: $id}) {
      nodes {
        id,
        idProduct,
        name,
        count,
        cost: price,
        pricePoints,
        group,
        deleted,
        smallSize,
        promocodeItem,
        category: categoryByIdCategory {
          idBrand
        }
        prod: productByIdProduct {
          idCategory,
          maxDiscount,
          description,
          burger
          isSale
          pizzaSize,
          idOriginCat,
          motivateSum
        }
      }
    }
  }
  `,
  LATEST_ORDERS_FROM_LAST_ORDER: gql`
  query latestOrdersFromLastOrder ($preorders: Boolean, $preordersWeek: Boolean, $notShow: Boolean, $num: Int, $lastId: Int, $new: Boolean, $stageId: Int, $restPointId: Int, $searchQuery: String) {
    latestOrdersFromLastOrder (flagPreorders: $preorders, displayPrevPreorders: $preordersWeek, notShowEndedOrders: $notShow, num: $num, lastId: $lastId, new: $new, stageId: $stageId, restPointId: $restPointId, searchQuery: $searchQuery)  {
      nodes  {
        ${fragments.callCenterOrdersItem}
      }
    }
  }`,
  LATEST_ORDERS_COUNT: gql`
  query latestOrdersCount ($preorders: Boolean, $preordersWeek: Boolean, $notShow: Boolean, $stageId: Int, $restPointId: Int, $searchQuery: String) {
    latestOrdersCount (flagPreorders: $preorders, displayPrevPreorders: $preordersWeek, notShowEndedOrders: $notShow, stageId: $stageId, restPointId: $restPointId, searchQuery: $searchQuery)
  }`,
  LAST_ORDERS_ID: gql`
    query lastOrdersId {
      lastOrdersId
    }
  `,
  ORDER_BY_ID: gql`
    query allOrders ($id: Int) {
      allOrders (condition: {
        id: $id
      }) {
        nodes {
          ${fragments.statusesOrder}
          ${fragments.orderInfoCallCenter}
          ${fragments.paymentOnlyInfo}
          promocode: promocodeByIdPromocode {
            ${fragments.promocodeInfo}
          }
        }
      }
    }
  `,
  ORDER_STATUSES_BY_ID: gql`
    query orderStatuses($order: Int!) {
      allStatusOrders(condition: { idOrder: $order }) {
        nodes {
          time
          idStageOrder
          workerByIdWorker {
            id
            firstName
            lastName
            secondName
          }
        }
      }
    }
  `,
  ORDERS_BATCH_GET: gql`
    query OrdersBatchGet($orderIds: [Int!]!) {
      ordersBatchGet(orderIds: $orderIds) {
        nodes {
          ${fragments.callCenterOrdersItem}
        }
      }
    }
  `,
  WORKER_IS_REST_MANAGER_BY_ID: gql`
    query AllWorkers ($id: Int) {
      allWorkers(condition: { id: $id }) {
        nodes {
          isRestManager
        }
      }
    }
  `
}



// WEBPACK FOOTER //
// ./src/constants/graphqlOrderManagment.js